<template lang="pug">
  header#header.pb-1
    b-row.form-box.mx-auto
      b-col.text-left
        img.mb-0.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
        img.mb-0.ml-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
      b-col.text-right
        p.mb-0.mt-2.font-weight-bold クラウド版サポートサイト【仮登録】
</template>

<script>
export default {
  name: "TmpOrderHeader",
}
</script>

<style scoped>
#header {
  padding: 10px;
  text-align: center;
  border-bottom: black 1px solid;
  font-size: 100%;
}
.logo_desknets {
  position: relative;
  width: 200px;
  bottom: 3px;
}
.logo_chatluck {
  width: 200px;
}
.form-box {
  max-width: 1200px;
}
</style>